module.exports = __webpack_public_path__ + "img/big-img-first-block-mobile.d7e62fa2.svg";